import { AiSystemDeployment } from './aiSystemDeployment';
import { DeploySystemReviewDetail } from './deploy-system-review';

export type DeploySystemCorrectionDetailContext = 'CORRECTION';

export const deploySystemCorrectionDetailContext: DeploySystemCorrectionDetailContext = 'CORRECTION';

export interface DeploySystemCorrectionDetailRequest {
  detail: 'execution';
  id_sistema: string;
  role: DeploySystemCorrectionDetailContext;
}

export type DeploySystemCorrectionFormField = keyof AiSystemDeployment;
export type DeploySystemCorrectionObservedField = DeploySystemCorrectionFormField;
export type DeploySystemCorrectionStep = 1 | 2 | 3 | 4 | 5 | 6;

export interface DeploySystemCorrectionObservedFieldStatus {
  field: DeploySystemCorrectionObservedField;
  valid: boolean;
}

export interface DeploySystemCorrectionDetail extends DeploySystemReviewDetail {
  systemCode?: string | null;
  correctionFields?: string[];
  publicValue?: boolean | string | null;
}

export type DeploySystemCorrectionRole = 'responsable_IA' | 'jefe_consumidor';

export interface DeploySystemCorrectionFieldMapEntry {
  detailField: string;
  formField: DeploySystemCorrectionFormField;
  step: DeploySystemCorrectionStep;
  stepLabel: string;
  fieldLabel: string;
}

export interface DeploySystemCorrectionFieldSummaryItem {
  formField: DeploySystemCorrectionObservedField;
  label: string;
}

export interface DeploySystemCorrectionStepSummary {
  step: DeploySystemCorrectionStep;
  stepLabel: string;
  fields: DeploySystemCorrectionFieldSummaryItem[];
}

export interface DeploySystemCorrectionSubmitPayload {
  executionSystemId: number;
  role?: DeploySystemCorrectionRole | null;
  orgCode?: string | null;
  biases: string | null;
  risks: string | null;
  usageInstructions: string | null;
  csvHumanSupervision: string | null;
  inputDataQuality: string | null;
  qualityMonitoring: string | null;
  logRetention: string | null;
  fria: string | null;
  dpia: string | null;
  naturalPersonInteractionCheck: boolean | null;
  contentGenerationCheck: boolean | null;
  biometricsEmotionsCheck: boolean | null;
  publicInterestTextCheck: boolean | null;
  userInformation: string | null;
  aiInfrastructure: string | null;
  integrationMode: string | null;
  dataSource: string | null;
  timePeriod: string | null;
  dataCategory: string[];
  csvQualityAccreditation: string | null;
  inputDataSource: string | null;
  sourceCode: string | null;
  iso42001Check: boolean | null;
  iso42001: string | null;
  csvISO42001: string | null;
  dataSovereigntyCheck: boolean | null;
  dataSovereignty: string | null;
  equityAndAccessCheck: boolean | null;
  equityAndAccess: string | null;
  updateCheck: boolean | null;
  aiSystemUpdate: string | null;
  latencyCheck: boolean | null;
  latencyPerformance: string | null;
  scalabilityCheck: boolean | null;
  csvScalability: string | null;
  contingencyPlanCheck: boolean | null;
  csvContingencyPlan: string | null;
  cybersecurityCheck: boolean | null;
  cybersecurity: string | null;
  csvCybersecurity: string | null;
  accessControlCheck: boolean | null;
  accessControl: string | null;
  attackProtectionCheck: boolean | null;
  attackProtection: string | null;
  csvAttackProtection: string | null;
  resilienceCheck: boolean | null;
  resilience: string | null;
  costBenefitAnalysisCheck: boolean | null;
  costBenefitAnalysis: string | null;
  csvCostBenefit: string | null;
  publicValueCheck: boolean | null;
  publicValueDescription: string | null;
}

export interface DeploySystemCorrectionSubmitResponse {
  statusCode: number;
  headers: string;
  body: {
    message?: string;
  };
}
